export default "__VITE_ASSET__cWiznmLb__"